/**
 * Product Flavor Drawer
 * Opens a right-side drawer with flavor details fetched via AJAX.
 * Autonomous JS — no dependency on other theme JS files.
 */

(function () {
  let drawerContainer = null;
  let currentHandle = null;
  const cache = {};

  let videoModal = null;

  function init() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-flavor-drawer-trigger]');
      if (trigger) {
        e.preventDefault();
        var handle = trigger.dataset.productHandle;
        if (handle) openDrawer(handle);
        return;
      }

      var videoTrigger = e.target.closest('[data-video-modal-trigger]');
      if (videoTrigger) {
        e.preventDefault();
        var url = videoTrigger.dataset.videoUrl;
        if (url) openVideoModal(url);
        return;
      }

      var videoClose = e.target.closest('[data-video-modal-close]');
      if (videoClose) {
        closeVideoModal();
        return;
      }

      if (videoModal && e.target === videoModal) {
        closeVideoModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (videoModal && videoModal.classList.contains('is-open')) {
          closeVideoModal();
        } else if (drawerContainer) {
          closeDrawer();
        }
      }
    });
  }

  function openVideoModal(url) {
    if (!videoModal) {
      videoModal = document.createElement('div');
      videoModal.className = 'video-modal';
      videoModal.innerHTML =
        '<div class="video-modal__content">' +
          '<button type="button" class="video-modal__close" data-video-modal-close aria-label="Fermer">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">' +
              '<path d="M9.83496 1.25L1.25 10.1904" stroke="white" stroke-width="2.5" stroke-linecap="round"/>' +
              '<path d="M1.25 1.25L9.83496 10.1904" stroke="white" stroke-width="2.5" stroke-linecap="round"/>' +
            '</svg>' +
          '</button>' +
          '<video class="video-modal__video" controls playsinline></video>' +
        '</div>';
      document.body.appendChild(videoModal);
    }

    var video = videoModal.querySelector('.video-modal__video');
    video.src = url;
    video.currentTime = 0;

    requestAnimationFrame(function () {
      videoModal.classList.add('is-open');
      video.play();
    });
  }

  function closeVideoModal() {
    if (!videoModal) return;
    var video = videoModal.querySelector('.video-modal__video');
    video.pause();
    video.src = '';
    videoModal.classList.remove('is-open');
  }

  function createContainer() {
    const container = document.createElement('div');
    container.className = 'product-flavor-drawer-container';
    container.innerHTML =
      '<div class="product-flavor-drawer-overlay" data-drawer-overlay></div>' +
      '<div class="product-flavor-drawer-panel">' +
        '<button type="button" class="product-flavor-drawer__close" data-drawer-close aria-label="Fermer">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">' +
            '<path d="M9.83496 1.25L1.25 10.1904" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>' +
            '<path d="M1.25 1.25L9.83496 10.1904" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>' +
        '<div class="product-flavor-drawer-panel__scroll">' +
          '<div class="product-flavor-drawer-panel__content"></div>' +
        '</div>' +
      '</div>';

    container.querySelector('[data-drawer-overlay]').addEventListener('click', closeDrawer);
    container.querySelector('[data-drawer-close]').addEventListener('click', closeDrawer);

    document.body.appendChild(container);
    return container;
  }

  function openDrawer(handle) {
    if (currentHandle === handle && drawerContainer && drawerContainer.classList.contains('is-open')) {
      return;
    }

    if (!drawerContainer) {
      drawerContainer = createContainer();
    }

    const contentEl = drawerContainer.querySelector('.product-flavor-drawer-panel__content');
    currentHandle = handle;

    // Lock body scroll
    document.body.style.overflow = 'hidden';

    // Show container then animate open
    requestAnimationFrame(function () {
      drawerContainer.classList.add('is-open');
    });

    if (cache[handle]) {
      contentEl.innerHTML = cache[handle];
      initAccordions(contentEl);
      initGalleryDrag(contentEl);
      return;
    }

    contentEl.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;padding:60px 0;"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner{transform-origin:center;animation:spin .75s infinite linear}@keyframes spin{100%{transform:rotate(360deg)}}</style><circle class="spinner" cx="12" cy="12" r="10" fill="none" stroke="#08453b" stroke-width="2" stroke-dasharray="47" stroke-linecap="round"/></svg></div>';

    fetch('/products/' + handle + '?view=flavor-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        cache[handle] = html;
        if (currentHandle === handle) {
          contentEl.innerHTML = html;
          initAccordions(contentEl);
          initGalleryDrag(contentEl);
        }
      })
      .catch(function () {
        contentEl.innerHTML = '<p style="padding:30px;text-align:center;">Impossible de charger les informations.</p>';
      });
  }

  function closeDrawer() {
    if (!drawerContainer) return;
    drawerContainer.classList.remove('is-open');
    document.body.style.overflow = '';
    currentHandle = null;
  }

  function initAccordions(root) {
    var toggles = root.querySelectorAll('[data-accordion-toggle]');
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var accordion = toggle.closest('[data-accordion]');
        var wasOpen = accordion.classList.contains('is-open');

        // Close all accordions
        root.querySelectorAll('[data-accordion]').forEach(function (a) {
          a.classList.remove('is-open');
        });

        // Open clicked one if it was closed
        if (!wasOpen) {
          accordion.classList.add('is-open');
        }
      });
    });
  }

  function initGalleryDrag(root) {
    var gallery = root.querySelector('.product-flavor-drawer__gallery');
    if (!gallery) return;

    var isDown = false;
    var startX;
    var scrollLeft;

    gallery.addEventListener('mousedown', function (e) {
      isDown = true;
      gallery.style.cursor = 'grabbing';
      startX = e.pageX - gallery.offsetLeft;
      scrollLeft = gallery.scrollLeft;
    });

    gallery.addEventListener('mouseleave', function () {
      isDown = false;
      gallery.style.cursor = '';
    });

    gallery.addEventListener('mouseup', function () {
      isDown = false;
      gallery.style.cursor = '';
    });

    gallery.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - gallery.offsetLeft;
      var walk = (x - startX) * 1.5;
      gallery.scrollLeft = scrollLeft - walk;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
